module.exports = __webpack_public_path__ + "img/imdb.8bed99a1.svg";